import type { Language } from '@/bindings/Language'
import { type MessageKey, type Messages, en } from '@/lib/i18n/messages/en'
import { vi } from '@/lib/i18n/messages/vi'
import { getLanguage, useLanguage } from '@/lib/i18n/store'

const dictionaries: Record<Language, Messages> = { en, vi }

export type Params = Record<string, unknown>

/** `{name}` → `String(params.name)`; an unknown placeholder is left as-is so it shows up in QA. */
export function interpolate(template: string, params: Params = {}): string {
  return template.replace(/\{(\w+)}/g, (match, name: string) =>
    name in params ? String(params[name]) : match,
  )
}

export function translate(language: Language, key: MessageKey, params?: Params): string {
  return interpolate(dictionaries[language][key], params)
}

/** Non-hook form for code outside React (router loaders, toasts). */
export function t(key: MessageKey, params?: Params): string {
  return translate(getLanguage(), key, params)
}

export type Translate = (key: MessageKey, params?: Params) => string

/** Re-renders on language change. */
export function useT(): Translate {
  const language = useLanguage()
  return (key, params) => translate(language, key, params)
}
